// state.order.itemID not null that mean modify order items
// state.order.currentID null that mean add new order.
// back to order list need clear state.order.currentID and state.order.itemID and state.order.order_no

import React, { useEffect, useState } from "react";
import { Button, List} from "antd";
import { useStateContext } from "../../Store/StateProvider";
import { useHistory } from "react-router-dom";
import { getDataForTable } from "../../Utils/getDataForTable";
import AddProduct from "./AddProduct";
import { productAction } from "../../Reducers/product_reducer";

export default function Product(props: any) {
  let [modalVisiable, setModalVisiable] = useState(false);  
  let [data,setData] = useState()
  let [pageTotal, setPageTotal] = useState();
  let [state,dispatch]=useStateContext()
  let history =useHistory()


  let [
    pageSize,
    pageNo,
    searchField,
    searchContent,
    between,
    conditionType,
    queryType,
    orderBy,
    sortBy,
  ] = Object.values(state.product);

  useEffect(() => {
    getDataForTable(
      {
        pageSize,
        pageNo,
        searchField,
        searchContent,
        between,
        conditionType,
        queryType,
        orderBy,
        sortBy,
      },
      setData,
      setPageTotal,
      "/api/products",
      "GET"
    );
    // fetchTableData();
  }, [
    pageSize,
    pageNo,
    searchField,
    searchContent,
    between,
    conditionType,
    queryType,
    orderBy,
    sortBy,
    state.product.reloadFlag,
  ]);
  return (
    <>
      <div
        style={{
          display: "table",
          width: "100%",
          height: "100%",
          maxHeight: "100%",
          maxWidth: 800
        }}
      >
        <div style={{ display: "table-row" }}>
          <div style={{ display: "table-cell",textAlign:'center' }}><h1>現有產品貨架位置</h1></div>        
        </div>
      </div>
      <div
      style={{
        display: "table",
        width: "100%",
        height: "100%",
        maxHeight: "100%",
      }}
    >
      <div style={{ display: "table-row" }}>
        <div style={{ display: "table-cell", textAlign: "center" }}>
          <List
           style={{maxHeight:460,height:450,overflow:'scroll'}}
            pagination={{
              onChange: (page) => {
                dispatch(
                  productAction({
                    pageNo: page,
                    reloadFlg: !state.product.reloadFlag,
                  })
                );
              },
              current: pageNo,
              total: pageTotal,
              pageSize: pageSize,
              defaultPageSize: 4,
            }}
            size="large"
            bordered
            dataSource={data}
            renderItem={(item: any) => (
              <List.Item>
                <div style={{ display: "table", width: "100%" }}>
                  <div style={{ display: "table-cell", width: "50%" }}>
                    {item.CBDESC}<br/>
                    {item.CODE}
                  </div>{" "}
                  <div style={{ display: "table-cell", width: "50%" }}>
                    {item.SHOP_GOODS_LOC}
                  </div>{" "}
                  <div style={{ display: "table-cell" }}>
                  
                     
                      <Button
                        type="dashed"
                        onClick={() => {
                          dispatch(productAction({currentID:item.CODE}));
                          setModalVisiable(true)
                          //history.push('/main/orderdetail')
                        }}
                      >
                        修改
                      </Button>
                   
                  </div>{" "}
                </div>
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>

      <AddProduct modalVisiable={modalVisiable} setModalVisiable={setModalVisiable}/>
      <div
        style={{
          display: "table",
          width: "100%",
          position: "fixed",
          bottom: 0,
          maxWidth: 800
        }}
      >
        <div style={{ display: "table-row", padding: 10 }}>
          <div
            style={{
              display: "table-cell",
              textAlign: "center",
              padding: 10,
              height: 80,
            }}
          >
            <Button type="primary" size="large" onClick={()=>{setModalVisiable(true)}}>
              輸入貨架資料
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
